export const filterObjectByKeyArr = (arr, data) => {
  let newData = { ...data };
  arr.forEach(key => delete newData[key]);
  return newData;
};
